import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import React, { useEffect } from "react";

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(false);

  const [sticky, setSticky] = useState("");

  // on render, set listener
  useEffect(() => {
    console.log("hello");
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    /* Method that will fix header after a specific scrollable */
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 10 ? "sticky-top" : "";
    setSticky(stickyClass);
    console.log(stickyClass);
  };

  const classes = `navbar mx-auto navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0 ${sticky}`;

  const [submenuOpen, setSubmenuOpen] = useState(false);
  const toggleSubmenu = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    setSubmenuOpen((prevState) => !prevState); // Toggle submenu visibility
  };

  return (
    <div className="mainheaderpage">
      <div className="headerwrap">
        <nav className={classes}>
          <a href="" className="navbar-brand p-0">
            <div className="ktig-container" style={{ textAlign: "center" }}>
              <h1 className="text-primary m-0">
                <Link to="/">
                  {" "}
                  <img
                    src="assets/img/logo/Tranparent-KTIG-Logo2.png"
                    alt="ktig-logo"
                  />
                </Link>
              </h1>
            </div>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav py-0">
              <NavLink
                to="/"
                className={
                  activeMenu === "/"
                    ? "nav-item nav-link cursor-pointer"
                    : "nav-item nav-link cursor-pointer"
                }
                onClick={() => {
                  setActiveMenu("/");
                }}
                active={activeMenu}
              >
                Home
              </NavLink>

              <div className="nav-item dropdown">
                <NavLink
                  href=""
                  data-bs-toggle="dropdown"
                  className={
                    activeMenu === ""
                      ? "nav-link dropdown-toggle cursor-pointer"
                      : "nav-link dropdown-toggle cursor-pointer"
                  }
                  onClick={() => {
                    setActiveMenu("");
                  }}
                  active={activeMenu}
                >
                  About Us
                </NavLink>
                <div className="dropdown-menu m-0 custom-dropdown-background">
                  <NavLink
                    to="/about-ktig"
                    className={
                      activeMenu === "/about-ktig"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/about-ktig");
                    }}
                    active={activeMenu}
                  >
                    About KTIG
                  </NavLink>

                  <NavLink
                    to="/vision-mission"
                    className={
                      activeMenu === "/vision-mission"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/vision-mission");
                    }}
                    active={activeMenu}
                  >
                    Vision & Mission
                  </NavLink>

                  <NavLink
                    to="/board-of-directories"
                    className={
                      activeMenu === "/board-of-directories"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/board-of-directories");
                    }}
                    active={activeMenu}
                  >
                    Board of Directories
                  </NavLink>
                </div>
              </div>

              <div className="nav-item dropdown">
                <NavLink
                  href=""
                  data-bs-toggle="dropdown"
                  className={
                    activeMenu === ""
                      ? "nav-link dropdown-toggle cursor-pointer"
                      : "nav-link dropdown-toggle cursor-pointer"
                  }
                  onClick={() => {
                    setActiveMenu("");
                  }}
                  active={activeMenu}
                >
                  Group of Companies
                </NavLink>
                <div className="dropdown-menu m-0 custom-dropdown-background">
                  <NavLink
                    to="/kovai-tech-nidhi-limited"
                    className={
                      activeMenu === "/kovai-tech-nidhi-limited"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/kovai-tech-nidhi-limited");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    Kovai Tech Nidhi Limited
                  </NavLink>
                  <NavLink
                    to="/kovai-tech-member-chamber"
                    className={
                      activeMenu === "/kovai-tech-nidhi-limited"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/kovai-tech-member-chamber");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    Kovai Tech Member Chamber
                  </NavLink>

                  <NavLink
                    to="/bnr-cogniitec"
                    className={
                      activeMenu === "/bnr-cogniitec"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/bnr-cogniitec");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    BNR Cogniitec Pvt Ltd
                  </NavLink>
                  <NavLink
                    to="/br-academy"
                    className={
                      activeMenu === "/br-academy"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/br-academy");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    BR Academy Pvt Ltd
                  </NavLink>
                  <NavLink
                    to="/skillorea"
                    className={
                      activeMenu === "/skillorea"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/skillorea");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    Skillorea Edutech Pvt Ltd
                  </NavLink>
                  <NavLink
                    to="/paval-soft"
                    className={
                      activeMenu === "/paval-soft"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/paval-soft");
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    active={activeMenu}
                  >
                    Paval Soft Pvt Ltd
                  </NavLink>
                </div>
              </div>

              <NavLink
                to="/events"
                className={
                  activeMenu === "/events"
                    ? "nav-item nav-link cursor-pointer"
                    : "nav-item nav-link cursor-pointer"
                }
                onClick={() => {
                  setActiveMenu("/events");
                }}
                active={activeMenu}
              >
                Events
              </NavLink>

              <div className="nav-item dropdown">
                <NavLink
                  href=""
                  data-bs-toggle="dropdown"
                  className={
                    activeMenu === ""
                      ? "nav-link dropdown-toggle cursor-pointer"
                      : "nav-link dropdown-toggle cursor-pointer"
                  }
                  onClick={() => {
                    setActiveMenu("");
                  }}
                  active={activeMenu}
                >
                  Innovest
                </NavLink>
                <div className="dropdown-menu m-0 custom-dropdown-background">
                  <NavLink
                    to="/finance-partner"
                    className={
                      activeMenu === "/finance-partner"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/finance-partner");
                    }}
                    active={activeMenu}
                  >
                    Finance Partner
                  </NavLink>

                  <NavLink
                    to="/joint-venture-partner"
                    className={
                      activeMenu === "/joint-venture-partner"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/joint-venture-partner");
                    }}
                    active={activeMenu}
                  >
                    Joint Venture Partner
                  </NavLink>

                  <NavLink
                    to="/consulting-partner"
                    className={
                      activeMenu === "/consulting-partner"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/consulting partner");
                    }}
                    active={activeMenu}
                  >
                    Consulting Partner
                  </NavLink>

                  <NavLink
                    to="/sponsorship-partner"
                    className={
                      activeMenu === "/sponsorship-partner"
                        ? "dropdown-item cursor-pointer"
                        : "dropdown-item cursor-pointer"
                    }
                    onClick={() => {
                      setActiveMenu("/sponsorship-partner");
                    }}
                    active={activeMenu}
                  >
                    Sponsorship Partner
                  </NavLink>
                </div>
              </div>

              <NavLink
                to="/blog"
                className={
                  activeMenu === "/blog"
                    ? "nav-item nav-link cursor-pointer"
                    : "nav-item nav-link cursor-pointer"
                }
                onClick={() => {
                  setActiveMenu("/blog");
                }}
                active={activeMenu}
              >
                Blog
              </NavLink>

              <NavLink
                to="/contact-us"
                className={
                  activeMenu === "/contact-us"
                    ? "nav-item nav-link cursor-pointer"
                    : "nav-item nav-link cursor-pointer"
                }
                onClick={() => {
                  setActiveMenu("/contact-us");
                }}
                active={activeMenu}
              >
                Contact Us
              </NavLink>
            </div>
            <div className="social_listtop d-xl-flex me-3">
              <div className="d-flex flex-column ps-3 pe-3 mb-3 text-white">
                <span>
                  Email :{" "}
                  <a
                    href="mailto:info@ktig.co.in"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    info@ktig.org.in
                  </a>
                </span>

                <a href="tel:+4733378901">
                  <div className="d-flex align-items-center justify-content-center ">
                    <a
                      className="btn btn-secondary me-3"
                      href="https://www.facebook.com/ktigcbe"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-3"
                      href="https://x.com/ktigcbe"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa fa-twitter "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-3"
                      href="https://www.instagram.com/ktigcbe_/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-0"
                      href="https://www.linkedin.com/company/ktig/?viewAsMember=true"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin-in "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-0"
                      href="https://www.youtube.com/@Ktigcbe"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-0"
                      href="https://www.pinterest.com/ktigcbe/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-pinterest "></i>
                    </a>
                    <a
                      className="btn btn-secondary me-0"
                      href="https://www.tumblr.com/blog/ktigcbe"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-tumblr"></i>
                    </a>
                    <a
                      className="btn btn-secondary me-0"
                      href="https://whatsapp.com/channel/0029VazHB8TFcow4tnamgs2x"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-whatsapp "></i>
                    </a>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
